import { getLink, Routes } from "@/constants";
import type { ActiveRoleType, UserRoleType, WorkspaceType } from "@/interFace/general";

const isSafeInternalPath = (value?: string | null): value is string => {
  if (typeof value !== "string" || !value.startsWith("/") || /[\\\u0000-\u0020\u007f]/.test(value)) return false;
  try {
    const url = new URL(value, "https://memocipe.invalid");
    const pathname = decodeURIComponent(url.pathname);
    return url.origin === "https://memocipe.invalid" && !pathname.startsWith("//") && !/[\\\u0000-\u0020\u007f]/.test(pathname);
  } catch {
    return false;
  }
};

export const resolvePostLoginUrl = ({
  locale,
  callbackUrl,
  defaultWorkspace,
  roles,
  activeRole,
}: {
  locale: string;
  callbackUrl?: string | null;
  defaultWorkspace?: WorkspaceType | null;
  roles?: UserRoleType[];
  activeRole?: ActiveRoleType;
}) => {
  if (isSafeInternalPath(callbackUrl)) {
    return callbackUrl;
  }

  const resolvedWorkspace = defaultWorkspace ?? null;

  if (resolvedWorkspace === "tutor") {
    return getLink(locale, Routes.TUTORS_ROOT);
  }

  if (resolvedWorkspace === "parent") {
    return getLink(locale, Routes.PARENTS_ROOT);
  }

  if (resolvedWorkspace === "claimant") {
    return getLink(locale, Routes.CLAIMANT_ROOT);
  }

  if (activeRole === "tutor" || roles?.includes("tutor")) {
    return getLink(locale, Routes.TUTORS_ROOT);
  }

  if (activeRole === "claimant" || roles?.includes("claimant")) {
    return getLink(locale, Routes.CLAIMANT_ROOT);
  }

  return getLink(locale, Routes.DASHBOARD_COURSES);
};